import gql from "graphql-tag";

export const GET_TEAM = gql`
    query Team($teamId: ID!){
        team(teamId: $teamId) {
            teamId
            userId
            teamName
            teamDescription
            createdAt
            updatedAt
            teamMembers {
                teamMemberUserId
                user {
                    displayName
                }
            }
        }
    }
`;

export const GET_TEAMS = gql`
    query Teams($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        teams(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            teamId
            userId
            teamName
            teamDescription
            createdAt
            updatedAt
            teamMembers {
                teamMemberUserId
                user {
                    displayName
                }
            }
        }
    }
`;

export const GET_TEAM_MEMBERSHIPS = gql`
    query TeamMemberships($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        teamMemberships(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            teamId
            userId
            teamName
            teamDescription
            createdAt
            updatedAt
            teamMembers {
                teamMemberUserId
                user {
                    displayName
                }
            }
        }
    }
`;

export const GET_TEAMS_OF_PARENT = gql`
    query TeamOfParent($parentType: String!, $parentId: ID!, $searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        teamOfParent(parentType: $parentType, parentId: $parentId, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            teamId
            userId
            teamName
            teamDescription
            createdAt
            updatedAt
            teamMembers {
                teamMemberUserId
                user {
                    displayName
                }
            }
        }
    }
`;

export const CREATE_TEAM = gql`
    mutation CreateTeam($newTeam: newTeam!) {
        createTeam(
            newTeam: $newTeam
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_TEAM = gql`
    mutation UpdateTeam($changedTeam: changedTeam!) {
        updateTeam(
            changedTeam: $changedTeam
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_TEAM = gql`
    mutation DeleteTeam($deleteTeamId: ID!) {
        deleteTeam(
            deleteTeamId: $deleteTeamId
        ) {
            returnCode
            message
        }
    }
`;
